import type { ReactElement } from 'react';
import { useEffect, useState } from 'react';

import { getError } from '@web-platform/global-components-utils/error-helpers/getError';
import { isStringsPropOk } from '@web-platform/global-components-utils/stringUtils';

import type { Logger } from '@web-platform/global-components-types/utils';

/** @internal */
type StringsPropVerificationProps = {
  stringsKeys: readonly string[];
  componentName: string;
  children: ReactElement;
  strings: { [p: string]: string };
  logger: Logger;
  isProductionEnv: boolean;
};

/** @internal */
const StringsPropVerification = ({
  children,
  componentName,
  isProductionEnv,
  logger,
  strings,
  stringsKeys,
}: StringsPropVerificationProps) => {
  const [prodError, setProdError] = useState(false);

  useEffect(() => {
    try {
      isStringsPropOk(stringsKeys, strings, componentName);
    } catch (error) {
      if (isProductionEnv) {
        // TODO: CLOV-1509: Suppressed for owners to look at while upgrading to eslint-plugin-react-hooks v7
        // eslint-disable-next-line react-hooks/set-state-in-effect
        setProdError(true);
        logger.logError(getError(error), {
          component: 'GlobalComponent_StringsPropVerification',
        });
      } else {
        // TODO: CLOV-1509: Suppressed for owners to look at while upgrading to eslint-plugin-react-hooks v7

        setProdError(false);
        throw error;
      }
    }
  }, [strings, componentName, logger, stringsKeys, isProductionEnv]);

  return prodError ? null : children;
};

export default StringsPropVerification;
